
import type { RouteObject } from "react-router-dom";
import AppShell from "../layout/AppShell";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Profile from "../pages/profile/page";
import PublicProfile from "../pages/profile/PublicProfile";
import Notifications from "../pages/notifications/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Admin from "../pages/admin/page";
import AdminLogin from "../pages/admin/AdminLogin";
import StoriesList from "../pages/stories/StoriesList";
import StoryDetail from "../pages/stories/StoryDetail";
import Pricing from "../pages/pricing/page";
import Billing from "../pages/account/billing/page";
import PublicPlaylistPage from "../pages/playlist/PublicPlaylistPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    element: <AppShell />,
    children: [
      { path: "/stories", element: <StoriesList /> },
      { path: "/stories/:id", element: <StoryDetail /> },
      { path: "/profile", element: <Profile /> },
      { path: "/u/:username", element: <PublicProfile /> },
      { path: "/playlist/:id", element: <PublicPlaylistPage /> },
      { path: "/notifications", element: <Notifications /> },
      { path: "/login", element: <Login /> },
      { path: "/register", element: <Register /> },
      { path: "/admin/login", element: <AdminLogin /> },
      { path: "/admin", element: <Admin /> },
      { path: "/pricing", element: <Pricing /> },
      { path: "/account/billing", element: <Billing /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;
